"use client";

import React from "react";
import { CircleCheck, ShieldCheck, Sparkles } from "lucide-react";
const inspections = [{
  title: "Brakes",
  description: "Pads, rotors, calipers check"
}, {
  title: "Tires",
  description: "Tread, pressure, leaks, rims"
}, {
  title: "Oil Leak",
  description: "Oil level and leak inspection"
}, {
  title: "General Check",
  description: "Quick safety look-over"
}];
export default function PremiumInspections() {
  return <section id="free-inspections" className="bg-[#F7F9FC] py-10">
      <div className="max-w-[1180px] mx-auto px-6 lg:px-8">
        <div className="relative overflow-hidden rounded-[24px] bg-white border border-[#E3E7EF] shadow-[0_18px_45px_rgba(7,27,58,0.10)]">
          
          <div className="absolute top-0 left-0 w-full h-[5px] bg-gradient-to-r from-[#FF5A00] via-[#0B4DBA] to-[#071B3A]" />
          <div className="absolute -right-20 -top-20 w-[260px] h-[260px] rounded-full bg-[#0B4DBA]/10 blur-3xl" />
          <div className="absolute -left-16 -bottom-20 w-[240px] h-[240px] rounded-full bg-[#FF5A00]/10 blur-3xl" />

          <div className="grid grid-cols-1 lg:grid-cols-[0.95fr_1.05fr] relative z-10">
            
            <div className="p-8 lg:p-10 bg-[#071B3A] text-white relative overflow-hidden">
              <div className="absolute right-0 top-0 h-full w-[18px] bg-[#0B4DBA] -skew-x-12" />
              <div className="absolute right-[28px] top-0 h-[130px] w-[7px] bg-[#FF5A00] -skew-x-12" />

              <div className="inline-flex items-center gap-2 bg-white/10 border border-white/15 px-4 py-2 rounded-md mb-6">
                <ShieldCheck className="w-4 h-4 text-[#7DB2FF]" />
                <span className="text-xs font-black uppercase tracking-widest">
                  Inspection is free
                </span>
              </div>

              <h2 className="text-[38px] lg:text-[54px] font-black italic uppercase leading-[0.88] mb-5">
                Free <br />
                <span className="text-[#7DB2FF]">Inspections</span>
              </h2>

              <p className="text-white/82 text-[16px] leading-relaxed max-w-[520px]">
                Stop by anytime. We’ll take a quick look at your brakes, tires,
                oil leaks, rims, and basic safety items — free.
              </p>

              <div className="mt-7 flex items-center gap-3 text-[#FFB37A] font-black uppercase tracking-widest text-xs">
                <Sparkles className="w-4 h-4" />
                No appointment needed — just drive in
              </div>
            </div>

            <div className="p-5 lg:p-7 grid grid-cols-2 gap-4 bg-white">
              {inspections.map((item, i) => <div key={i} className="group relative overflow-hidden bg-[#F8FAFD] rounded-[16px] border border-[#E3E7EF] p-4 shadow-sm hover:shadow-[0_12px_24px_rgba(7,27,58,0.09)] transition">
                  <div className="absolute top-0 left-0 w-full h-[4px] bg-[#0B4DBA] opacity-80" />
                  <CircleCheck className="w-6 h-6 text-[#0B4DBA] mb-3" />
                  <h3 className="font-black italic uppercase text-[17px] leading-none mb-2">
                    {item.title}
                  </h3>
                  <p className="text-[#5B6575] text-[12px] leading-snug">
                    {item.description}
                  </p>
                </div>)}
            </div>

          </div>
        </div>
      </div>
    </section>;
}